import { getImageUrl, sanitizeHTML } from "../../../utils/portfolioUtils";
import "../../../css/Resume.css";

const ResearchItem = ({ item }) => {
  return (
    <div className="research-item">
      {item.thumbnail && (
        <img
          src={getImageUrl(item.thumbnail)}
          alt={item.title}
          className="research-thumb"
        />
      )}
      <div className="research-content">
        <h5 className="mb-1">
          <strong>{item.title}</strong>
        </h5>
        <p className="authors mb-0">
          {item.authors}
          {item.shared_first_author && <sup>*</sup>}
        </p>
        {item.shared_first_author && (
          <small className="footnote mb-1 d-block">
            <sup>*</sup> – shared first authors
          </small>
        )}
        <div
          className="research-description mt-2 mb-0"
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(item.description) }}
        />
        {(item.arxiv_link ||
          item.slides_file ||
          item.poster_file ||
          item.code_link) && (
          <div className="paper-links">
            {item.arxiv_link && (
              <a
                href={item.arxiv_link}
                target="_blank"
                rel="noopener noreferrer"
                className="paper-link-tag"
              >
                arXiv
              </a>
            )}
            {item.code_link && (
              <a
                href={item.code_link}
                target="_blank"
                rel="noopener noreferrer"
                className="paper-link-tag"
              >
                code
              </a>
            )}
            {item.slides_file && (
              <a
                href={item.slides_file}
                target="_blank"
                rel="noopener noreferrer"
                className="paper-link-tag"
              >
                slides
              </a>
            )}
            {item.poster_file && (
              <a
                href={item.poster_file}
                target="_blank"
                rel="noopener noreferrer"
                className="paper-link-tag"
              >
                poster
              </a>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ResearchItem;
